import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import _ from 'lodash'
import Container from '../../containers/'
import Home from '../Home'
import Login from '../Login/Login'
import Anonimo from '../Anonimo'
import ContentAnalytics from '../ContentAnalytics/Dashboard'
import SocialIntelligence from '../SocialIntelligence/Dashboard/Dashboard'
import AdsIntelligence from '../AdsIntelligence/Dashboard/Dashboard'
import WebIntelligence from '../WebIntelligence/Dashboard/Dashboard'
import IndustryIntelligence from '../IndustryIntelligence/Dashboard/'
import RetailIntelligence from '../RetailIntelligence/Dashboard/'
import Calendar from '../Calendar/Dashboard'
import Overview from '../Overview/Dashboard'
import SalesBenchmark from '../SalesBenchmark'

import storage from '../../services/storage'
import { Theme } from '../../config'

import './styles.css'

class App extends Component {
  componentWillMount(){
    _.forEach(Theme, (hex, name)=>{
      document.documentElement.style.setProperty(name, hex)
    })
  }

  render() {
    return (
      <div className="App">
        <Route path="/anonimo" exact component={Anonimo} />
        <Route path="/" exact component={Login} />
        <Route path="/home" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Mission Control'>
              <Home />
            </Container>
        )}} />
        <Route path="/sales" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Sales Benchmark'>
              <SalesBenchmark />
            </Container>
        )}} />
        <Route path="/overview/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - ID'>
              <Overview />
            </Container>
        )}} />
        <Route path="/dashboard/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Dashboard'>
              <ContentAnalytics />
            </Container>
        )}} />
        <Route path="/social/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Content Optimization'>
              <SocialIntelligence />
            </Container>
          )}} />
        <Route path="/ads/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Ads Intel'>
              <AdsIntelligence />
            </Container>
          )}} />
        <Route path="/web/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Web Intel'>
              <WebIntelligence />
            </Container>
          )}} />
        <Route path="/calendar/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Calendar'>
              <Calendar />
            </Container>
          )}} />
        <Route path="/trending/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Trending'>
              <IndustryIntelligence />
            </Container>
          )}} />
        <Route path="/retail/:id" render={(props)=>{
          return (
            <Container {...props} title='S|M|A|R|T - Retail Intel'>
              <RetailIntelligence />
            </Container>
          )}} />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js